<script>
import moment from 'moment'
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import AlertDialog from '@components/alert-dialog.vue'
import { telehealthService } from '@src/services/safehaven/TelehealthService'

export default {
  components: { AlertDialog },
  page: {
    title: 'Confirm appointment',
    meta: [{ name: 'description', content: 'The Confirm Appointment page.' }],
  },
  mixins: [layout, NavigateMixin],
  data() {
    return {
      providerDetails: {},
      providerName: '',
      appointmentDate: '',
      appointmentTime: '',
      appointmentNotes: '',
      isShowAlert: false,
      alertTitle: '',
      errorMsg: '',
      alertMesasge: `During the telehealth meeting, your personal health information may be securely shared with the provider.`,
      linkText: 'View Privacy Policy',
      iBookingDisabled: false,
      appointmentDetails: {},
    }
  },
  mounted: function() {
    const isFromReschedule = this.$route.params.isFromReschedule

    if (isFromReschedule) {
      this.appointmentDetails = this.$route.params.appointmentDetails
    }

    this.providerDetails = this.$route.params.selectedProviderDetails
    this.appointmentDate = moment(this.providerDetails.selectedDate).format(
      'dddd, MMM D'
    )
    this.appointmentTime = this.providerDetails.selectedTimeSlot.start_time

    const todayDate = moment().format('MM/DD/YYYY')
    const bookingDate = moment(this.providerDetails.selectedDate).format(
      'MM/DD/YYYY'
    )
    const now = moment()
      .format('hh:mm A')
      .toString()
    const timeString = bookingDate + ' ' + this.appointmentTime
    const nowString = todayDate + ' ' + now
    const selectedTime = new Date(timeString).getTime()
    const currentTime = new Date(nowString).getTime()

    if (selectedTime < currentTime) {
      this.iBookingDisabled = true
      this.errorMsg = 'Please select an upcoming time slot'
    }
  },

  methods: {
    goBack() {
      this.$router.push({
        name: 'safehaven-provider-list',
        params: {
          selectedProvider: this.providerDetails.speciality,
          selectedDate: this.providerDetails.selectedDate,
          selectedProviderId: this.selectedProviderId,
          loadDetails: false,
        },
      })
    },
    bookAppointment() {
      this.navigateToScreen('safehaven-health-help')
    },
    showAlert() {
      this.isShowAlert = true
    },
    hideAlert() {
      this.isShowAlert = false
    },
    handleSuccess() {
      // Integrate Book appointment API here
      if (this.$route.params.isFromReschedule) {
        this.rescheduleMeeting()
      } else {
        this.telehealthAppointment()
      }
      this.isShowAlert = false
    },

    async telehealthAppointment() {
      const userData = this.$store.state.auth.currentUser.user

      var selectedSlot = this.providerDetails.available_slots.slot.find(
        (x) => x.start_time === this.providerDetails.selectedTimeSlot.start_time
      )
      try {
        const responseData = await telehealthService.bookAppointment({
          patient: userData.roles.patient,
          provider_id: this.providerDetails.provider_id,
          availability_det_id: selectedSlot.availability_det_id,
          provider_name:
            this.providerDetails.first_name +
            ' ' +
            this.providerDetails.last_name,
          provider_speciality: this.providerDetails.speciality,
          provider_credentials: this.providerDetails.credArr,

          appointment_date: this.providerDetails.selectedDate,
          appointment_end_time: moment(selectedSlot.end_time, [
            'h:mm A',
          ]).format('HH:mm:ss'),
          appointment_time: moment(selectedSlot.start_time, ['h:mm A']).format(
            'HH:mm:ss'
          ),
          additional_notes: this.appointmentNotes,
          video_conference_link: this.providerDetails.doxy_me_link || '',
        })
        if (responseData && responseData.data) {
          document.getElementById('updateCalneder').click()
          this.$router.push({
            name: 'event-details',
            params: { eventId: responseData.data.availability_det_id },
          })
        }
      } catch (error) {
        console.warn(error)
        this.errorMsg =
          'The selected timeslot has already been scheduled for another provider.'
        this.iBookingDisabled = true
      }
    },

    rescheduleMeeting() {
      this.loading = true
      const userData = this.$store.state.auth.currentUser.user
      const providerDetailReqObj = {
        old_availability_det_id: this.appointmentDetails.availability_det_id,
        old_appointment_date: this.appointmentDetails.appointment_date,
        patient: userData.roles.patient,
        patient_first_name: userData.first_name,
        patient_last_name: userData.last_name,
        appointment_date: this.providerDetails.selectedDate,
        appointment_time: this.providerDetails.selectedTimeSlot.start_time,
        appointment_end_time: this.providerDetails.selectedTimeSlot.end_time,
        provider_id: this.providerDetails.provider_id,
        provider_name: this.appointmentDetails.provider_name,
        availability_det_id: this.providerDetails.selectedTimeSlot
          .availability_det_id,
        patient_email: userData.email,
        provider_speciality: this.providerDetails.speciality,
        additional_notes: this.appointmentNotes,
        video_conference_link: this.providerDetails.doxy_me_link || '',
      }

      telehealthService
        .rescheduleMeeting(providerDetailReqObj)
        .then((res) => {
          if (res.status === 200) {
            this.$router.push({
              name: 'event-details',
              params: {
                eventId: this.providerDetails.selectedTimeSlot
                  .availability_det_id,
              },
            })
          }
          this.loading = false
        })
        .catch((error) => {
          console.warn('Rescheduling Error', error)
        })
    },
  },
}
</script>

<template>
  <v-container class="$style.mainContainer">
    <AlertDialog
      :show-alert="isShowAlert"
      :alert-title="alertTitle"
      :alert-message="alertMesasge"
      :link-text="linkText"
      @success="handleSuccess"
      @close-alert="hideAlert"
    ></AlertDialog>
    <v-row>
      <div class="pa-3">
        <v-row class="backButtonContainer">
          <a class="clickable primary--text" @click="goBack">Back</a>
        </v-row>
      </div>
    </v-row>
    <v-row>
      <v-col
        cols="24"
        sm="8"
        md="8"
        lg="4"
        xl="3"
        :align="notDesktop ? 'center' : 'start'"
        fill-height
      >
        <h3 class="peerHeading">Confirm Telehealth Meeting</h3>
        <div :class="$style.textContainer">
          <p :class="$style.titleText">Provider</p>
          <p :class="$style.appointmentText"
            >{{ providerDetails.first_name }} {{ providerDetails.last_name
            }}{{ providerDetails.credentials }}</p
          >
        </div>
        <div :class="$style.textContainer">
          <p :class="$style.titleText">Date</p>
          <p :class="$style.appointmentText"
            >{{ appointmentDate }}, {{ appointmentTime }}</p
          >
        </div>
        <div :class="$style.textContainer">
          <p :class="$style.additionalText">
            <span :class="$style.titleText">Additional Notes </span>
            <span>(optional)</span>
          </p>

          <v-textarea
            v-model="appointmentNotes"
            :class="$style.vtextArea"
            background-color="white"
            rows="4"
            counter="200"
            :maxlength="200"
            outlined
          ></v-textarea>
        </div>

        <v-row :class="$style.buttonContainer">
          <v-btn
            type="button"
            class="my-auto"
            color="primary"
            rounded
            :class="$style.fullWidthBtn"
            :disabled="iBookingDisabled === true"
            @click="showAlert"
          >
            Book Meeting
          </v-btn>
          <a
            class="clickable primary--text"
            :class="$style.cancelButton"
            @click="goBack"
            >Cancel</a
          >
        </v-row>
        <v-row v-if="errorMsg">
          <span :class="$style.serverErrorMsg">
            {{ errorMsg }}
          </span>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.mainContainer {
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.textContainer {
  margin-top: 20px;
  text-align: left;
}

.serverErrorMsg {
  margin-top: 14px;
  margin-left: 36px;
  font-size: 12px;
  color: #ca024f;
}

.titleText {
  margin-bottom: 0 !important;
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  color: #2c3a4b;
}

.appointmentText {
  margin-bottom: 0 !important;
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  color: #09101d;
  letter-spacing: -0.3px;
}

.additionalText {
  margin-bottom: -10px !important;
}

.vtextArea {
  margin-top: 15px !important;
}

.buttonContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 10px;
}

.fullWidthBtn {
  width: 50%;
  height: 46px !important;
  font-size: 15px !important;
  text-transform: unset !important;
}

.title {
  font-size: 28px;
  font-weight: 400;
}

.dialogMenu {
  border-radius: 9px !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.termsContainer {
  padding: 5px;
  margin-top: 30px !important;
}

.termsText {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  letter-spacing: 0;
}

.privacyText {
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  color: #0476d9;
  text-align: left;
  text-decoration: none;
  letter-spacing: 0;
}

@media screen and (max-width: 960px) {
  .buttonContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 10px;
  }

  .fullWidthBtn {
    width: 90%;
    height: 46px !important;
    font-size: 18px !important;
    text-transform: unset !important;
  }

  .cancelButton {
    margin-top: 10px;
  }

  .termsContainer {
    padding: 10px;
    margin-top: 20px !important;
  }
}
</style>

<style scoped>
.peerHeading {
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 38px;
  text-align: left;
  letter-spacing: -0.3px;
}

.backButtonContainer {
  align-items: center;
  padding: 10px;
}
</style>
